import { render, staticRenderFns } from "./RegisterSchoolForm.vue?vue&type=template&id=c15260c8&scoped=true&lang=pug&"
import script from "./RegisterSchoolForm.vue?vue&type=script&lang=js&"
export * from "./RegisterSchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSchoolForm.vue?vue&type=style&index=0&id=c15260c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15260c8",
  null
  
)

export default component.exports